import { ProductDateBasic } from '../../lib/types/models/product/product-date'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripJourneyDates(ids: number[]) {
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.trips.getTripJourneyDates.url, null), { ids }))
    .get<ProductDateBasic[]>()
}
